import _ from 'lodash';
import { useFetch } from 'plume-web-utils';
import { useRecoilValue } from 'recoil';

import { UseFetchCacheKeys } from '../../../cacheConfig';
import { DependencyContainer } from '../../../DependencyContainer';
import { activePartnerAtom } from '../../../state';

const { monitorsService } = new DependencyContainer();

const useAutonomousMonitors = () => {
  const activePartner = useRecoilValue(activePartnerAtom);

  return useFetch(
    async () => {
      if (!activePartner?.id) return;
      const data = await monitorsService.getAutonomousMonitorsList(
        activePartner.id,
      );
      return _.sortBy(data, 'name');
    },
    {
      dependencies: [activePartner?.id],
      skip: !activePartner || !activePartner?.id,
      cacheKey: UseFetchCacheKeys.AutonomousMonitorList,
    },
  );
};

export default useAutonomousMonitors;
